export default __webpack_public_path__ + "locales/en/SocialAuthWelcomeDialog.json?hash=a877674ff0d1c5ad8b26edc5028ed328";